$(document).ready(function() {

  if ($(".banner").length) {
    $(document).on('click', '.banner', function () {
      var redirect = $(this).find("a").attr("href");
      if (redirect) {
        $(".banner").css("cursor", "pointer");
        window.location.href = redirect;
      }
    });
  }

   // Changement de langue
   $("#FooterLanguageForm span").on("click", function(e) {
      $(this).siblings('input[name=locale_code]').val($(this).data("value"));
      $(this).parent().submit();
   });

   // Ouverture description produit
   $(".read_more").on("click", function(e) {
      $(this).prev('.clamped').toggleClass("extend");
   });

   // Ouverture mot douc panier
   $(".cart__note label").on("click", function(e) {
      $(this).next("textarea").toggle();
      $(this).find("svg").toggleClass("opened closed");
   });

   // Header transparent sur la home
   $(".transparent_header .header-wrapper").hover(function() {
      $(".transparent_header .announcement-bar").addClass("regular_header");
   }, function() {
      $(".transparent_header .announcement-bar").removeClass("regular_header");
   });

   if ($(window).width() < 768) {
      $("body").removeClass("transparent_header");
   }

   // Menu mobile
   $(".level_1_mobile > li > .menu-drawer__menu-item").click(function(e) {
      var title = $(".level_1_mobile > li > .menu-drawer__menu-item");
      var answers = $(".level_1_mobile > li > div")
      $(this).toggleClass("opened");
      if (answers.length) {
         $(title).not($(this)).removeClass("opened");
         $(title).not($(this)).next(answers).slideUp();
         $(this).next("div").slideToggle();
      }
   });

    // Slider images page charte
   $('.slider_charte .rte').slick({
      slidesToShow: 5,
      infinite: true,
      arrows: true,
       responsive: [
         {
            breakpoint: 1440,
            settings: {
               slidesToShow: 4,
            }
         },
         {
            breakpoint: 1160,
            settings: {
               slidesToShow: 3,
            }
         },
         {
            breakpoint: 820,
            settings: {
               slidesToShow: 2,
            }
         },
         {
            breakpoint: 750,
            settings: {
               slidesToShow: 1,
            }
         }
      ]
   });

    // Slider images page charte
   $('.card_product_cart').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplaySpeed: 3000,
      arrows: false,
      fade: true,
      autoplay: true,
      dots: false
   });

   // Section slider de produit
/*    var products_slider = $(".slider-component-desktop").height();
   console.log(products_slider);
   $('.product_slider').height(products_slider / 6);
 */

   // Product page
    // Sticky addtocart en mobile
    // Sticky button sur fiche produit
    $("#sticky_basket").click(function () {
      if ($(this).hasClass("redirect")) {
        $(".product-form__submit").click();
      } else {
        $([document.documentElement, document.body]).animate({
          scrollTop: $(".product__info-wrapper").offset().top + 60
        }, 400);
      }
    });

   // Slider réassurance
   $('.product-reassurance').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 2500,
      arrows: false,
      dots: true
   });

   $("#inci").on("click", function(e) {
      $("#inci_pop").fadeIn(function () {
         $("#inci_pop .pop_content").fadeIn();
      });
   });

   // Fermeture popin (?)
   $(".close").on("click", function(e) {
      $(".pop_content").fadeOut();
      $(".pop").fadeOut();
   });


   // Pages FAQ : accordeon
   // Comportement questions FAQ, CGV, Mentions
   $(".accordeon h3").on("click", function(e) {
      var questions = $(".accordeon h3");
      var answers = $(".accordeon > div");
      $(this).toggleClass("opened");
      if (answers.length) {
         $(questions).not($(this)).removeClass("opened");
         $(this).next("div").slideToggle();
      }
   });

      // Popin d'inscription newsletter en homepage
   var PromoCookie = {};
   PromoCookie.cookie = {
      configuration: {
         expires: null, //session cookie
         path: '/',
         domain: window.location.hostname
      },
      name: 'newsletter_home',
      write: function(promo) {
         $.cookie(this.name, promo, this.configuration);
      },
      read: function() {
         return $.cookie(this.name);
      }
   };
   var cookieExists = PromoCookie.cookie.read();

  /*  if(!cookieExists) {
      PromoCookie.cookie.write('newsletter_home');
      var $thisModal = $('#newsletter_popin');
      $thisModal.delay(5000).fadeIn('fast');
   }
   else {
      // Si l'url contient "?customer_posted=true", on doit afficher la popin également
      let searchParams = new URLSearchParams(window.location.search);
      if(searchParams.has('customer_posted')){
         var $thisModal = $('#newsletter_popin');
         $thisModal.fadeIn('fast');
      }
   } */

});


function isInViewport(el) {
  if (typeof el.get(0) === 'undefined') {
    return false;
  }

  const rect = el.get(0).getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= ($(window).height() || $(document).height()) &&
    rect.right <= ($(window).width() || $(document).width())
  );
}

// Au scroll
const add_to_cart_buttons = $('.product-form__buttons');
const sticky_basket = $('#shopify-section-sticky_basket');

$(document).scroll(function () {

  if (add_to_cart_buttons.length === 0) {
    return;
  }

  const isVisible = isInViewport(add_to_cart_buttons);

  if (isVisible) {
    sticky_basket.slideUp(200);
  }
  else {
    sticky_basket.slideDown(200);
  }
});